<mat-form-field class="w-full">
  <mat-label>
    {{ dropdownLabel }}
  </mat-label>
  <mat-select
    [required]="required"
    [formControl]="dropdownSelectionFormControl"
    (selectionChange)="onSelectionChange()"
    #singleSelect
    >
    <mat-option>
      <ngx-mat-select-search
        [formControl]="searchBarFormControl"
        [noEntriesFoundLabel]="noOptionsText"
        placeholderLabel="Start typing to find Clinic"
        >
      </ngx-mat-select-search>
    </mat-option>
    @for (option of filteredDropdownOptions; track option) {
      <mat-option
        [value]="option.name"
        >
        <span>{{ option.name }}</span>
      </mat-option>
    }
  </mat-select>
  @if (showError && dropdownSelectionFormControl.hasError('required')) {
    <mat-error>
      Please select clinic.
    </mat-error>
  }
</mat-form-field>
